import { typedQueryClient, useTypedMutation } from "hooks";
import { AppointmentDetailsKeys } from "modules/AppointmentDetails/queryKeys";
import { ApiInstance } from "utils/Api";

export type UpdateInterventionPayload = {
  customer_ok: boolean;
  description?: string;
  title?: string;
  price?: number;
  visible_to_customer: boolean;
  appointment_id: number;
  id: number;
  dms_nr?: string;
};

export const useUpdateInterventionMutation = () =>
  useTypedMutation<UpdateInterventionPayload, void>({
    mutationFn: async payload => {
      await ApiInstance.post("/interventions/update", payload);
    },
    onSuccess: payload => {
      const appointment = typedQueryClient.getQueryData(AppointmentDetailsKeys.view);
      if (!appointment?.interventions?.length) return;

      const interventionIdx = appointment.interventions.findIndex(intervention => intervention.id === payload.id);
      if (interventionIdx < 0) return;

      typedQueryClient.setQueryData(AppointmentDetailsKeys.view, {
        ...appointment,
        interventions: appointment.interventions.with(interventionIdx, { ...appointment.interventions[interventionIdx], ...payload })
      });
    }
  });
